const LoanIcon = () => {
  return (
    <svg viewBox="0 0 17.357 18">
      <g transform="translate(-31.578 -15.789)">
        <path
          data-name="Path 245"
          d="M39.935,15.789a1.285,1.285,0,0,0-1.286,1.286v1.286a1.286,1.286,0,1,0-2.571,0v.178a1.278,1.278,0,0,0-1.929,1.107v.643H32.864a1.187,1.187,0,0,0-.249.025l-.02,0a1.285,1.285,0,0,0-1.017,1.256v7.071a1.3,1.3,0,0,0,1.286,1.286H34.15a3.858,3.858,0,0,0,3.857,3.857h2.371a5.143,5.143,0,0,0,3.636-1.507l2.029-2.029,2.893-1.3c-.007-1.225-.967-1.6-1.929-1.6a6.386,6.386,0,0,0-3.214.964l-.643.321H32.864V22.861a1.285,1.285,0,0,0,1.286-1.286H45.721a1.285,1.285,0,0,0,1.286,1.286v3.214h1.286v-4.5a1.187,1.187,0,0,0-.025-.249c0-.007,0-.013-.005-.02a1.284,1.284,0,0,0-1.255-1.017H43.792V17.718a1.286,1.286,0,1,0-2.571,0v-.643A1.285,1.285,0,0,0,39.935,15.789Zm9,13.169v0Zm-9-6.1a2.746,2.746,0,0,0-2.572,2.893,3.042,3.042,0,0,0,.462,1.607h4.219a3.042,3.042,0,0,0,.462-1.607A2.746,2.746,0,0,0,39.935,22.861Zm-5.143,1.929a.643.643,0,1,0,.643.643A.644.644,0,0,0,34.792,24.789Zm10.286,0a.643.643,0,1,0,.643.643A.644.644,0,0,0,45.078,24.789Z"
          transform="translate(0)"
        />
      </g>
    </svg>
  );
};

export default LoanIcon;
